'use strict';

const GTM = require('../global/gtm');

module.exports = {

    trackInit: function () {
        let dataAlreadyPushed = false;
        document.querySelectorAll('.btn-club-subscription').forEach(element => {
            element.addEventListener('click', function () {
                if (dataAlreadyPushed) return;
                dataAlreadyPushed = true;
                const sideModal = document.querySelector('#sideModal');
                if (sideModal) {
                    sideModal.setAttribute('data-subscription-stepName', 'landing_page_cta');
                }
                const subOrigin = element.getAttribute('data-subscription-origin') || 'unknown';
                GTM.pushToDataLayer({
                    event: 'club_tunnel_open',
                    club_tunnel_step: 'landing_page_cta',
                    subscription_origin: subOrigin
                });
            });
        });
    },
    trackAbandon: function () {
        let dataAlreadyPushed = false;
        window.addEventListener('beforeunload', () => {
            const stepName = document.querySelector('[data-subscription-stepName]').getAttribute('data-subscription-stepName') || 'unknown';
            if (dataAlreadyPushed || stepName === 'success') return;
            dataAlreadyPushed = true;
            GTM.pushToDataLayer({
                event: 'club_tunnel_abandon',
                club_tunnel_step: stepName
            });
        });
    },
    bindStepListener: function () {
        window.addEventListener('core:subscription-tunnel-step', (event) => {
            const stepName = event.detail.stepName;
            const element = document.querySelector('[data-subscription-stepName]');
            if (element && stepName) {
                element.setAttribute('data-subscription-stepName', stepName);
            }
        });
    }
};
